import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Darknet Alert · Your Cybersecurity Guardian</p>
        <h1>Stay One Step Ahead of Cyber Threats</h1>
        <p className="lede">
          Protect your personal information with real-time alerts for activities and breaches on the dark web. 
          Our platform empowers you to take action before it's too late.
        </p>
        <div className="cta-row">
          <a href="/learn-more" target="_self">
            Learn More
          </a>
          <a href="/sign-up" target="_self" className="secondary">
            Get Started
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Real-Time Alerts</h2>
          <p>
            Receive instant notifications about potential threats to your personal data, ensuring you stay informed and protected.
          </p>
        </article>
        <article>
          <h2>Comprehensive Monitoring</h2>
          <p>
            Our advanced algorithms continuously scan the dark web for any signs of your information being compromised.
          </p>
        </article>
        <article>
          <h2>Take Control</h2>
          <p>
            With actionable insights at your fingertips, you can respond quickly to threats and safeguard your online presence.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;